<template>
  <div class="container-fluid">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'ClusterLayout'
}
</script>

<style scoped>
</style>
